module.exports = __webpack_public_path__ + "fonts/font.9d6dcdb1.woff2";